module.exports = __webpack_public_path__ + "img/2_m.9f45ace2.jpg";